import { useState } from 'react';
import { api } from '../lib/api';

/**
 * Somebody's profile photo, falling back to their initial.
 *
 * Every avatar in the app used to be a letter. Rendering the photo behind the
 * same letter means the fallback is already in place if the request fails or
 * the person never set one — nothing pops in or reflows.
 */
export function Avatar({
  userId,
  displayName,
  size = 40,
  className = '',
}: {
  userId: string | null | undefined;
  displayName: string;
  /** Rendered size in CSS pixels; the image is requested at 2x for retina. */
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const initial = (displayName || '?').slice(0, 1).toUpperCase();

  return (
    <span className={`avatar ${className}`} aria-hidden="true">
      <span className="avatar-initial">{initial}</span>
      {userId && !failed && (
        <img
          className="avatar-image"
          src={api.avatarUrl(userId, Math.min(size * 2, 512))}
          alt=""
          loading="lazy"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
}
